module.exports = __webpack_public_path__ + "img/carrusel_2.fce8b7ec.svg";